import { MenuItem } from '@mui/material'
import { ApproveWithCommentPendingActionDialog } from 'components/pages/task/details/task-content-v2/common/ApproveWithCommentPendingActionDialog'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type ApproveWithCommentPendingDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const ApproveWithCommentPendingDropdownOption: FC<ApproveWithCommentPendingDropdownOptionProps> = ({
    task,
    close,
}) => {
    const { open } = useSimpleModal()

    const handleClick = (): void => {
        if (!task.accessReview?.id) return

        open(ApproveWithCommentPendingActionDialog, {
            task,
        })()
        close()
    }

    return (
        <MenuItem
            onClick={handleClick}
            key={`components_task_actions_dropdown_approve_with_comment_pending_task_${task.id}`}
        >
            <FormattedMessage
                id="component_task_list_approve_comment_pending_option_label"
                defaultMessage="Certify with comment"
            />
        </MenuItem>
    )
}
